export enum TimerButtonState {
  PLAY = "PLAY",
  PAUSE = "PAUSE",
  STOP = "STOP"
}
